<template>
  <QuadroPrincipal borderTop :titulo="titulo" class="arredonda-borda" :classe="classe">
    <div class="box-sem-tributo-corpo">
      <div>
        <font-awesome-icon icon="file-alt" />
      </div>
      <div>
        <p>
          Erro ao buscar resultado para o imposto de <b>{{ titulo }}</b
          >.
        </p>
      </div>
    </div>
  </QuadroPrincipal>
</template>

<script>
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
export default {
  name: "MensagemErro",

  props: {
    titulo: String,
    classe: String
  },

  // inject: ["controleAbas"],

  components: {
    QuadroPrincipal
  },

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>

<style lang="scss" scoped>
.box-sem-tributo-corpo {
  height: 140px;
  width: 80%;
  margin: 0px auto;
  border: 2px solid #e01919;
  background: #ececec;
  padding: 0px 25px;
  font-size: 15px;
  color: #e20c0c;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // cursor: pointer;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;

    &:first-child {
      padding: 0 20px;
      border-right: 1px solid #999;
    }

    &:last-child {
      margin: 0 10px;
      p {
        margin: 0 0 0 10px;
      }
    }

    .svg-inline--fa {
      font-size: 44px;
      margin-left: 0px;
    }
  }
}
.quadro-principal {
  height: 210px;
  display: flex;
  align-items: center;
}
.arredonda-borda {
  border-radius: 10px;
}
</style>
